import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import Header from './components/Header';
import MobileSideMenu from './components/MobileSideMenu';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import MobileDevices from './assets/mobile-devices-group.png';
import SectionTwo from './components/SectionTwo';
import SectionFour from './components/SectionFour';
import SectionFive from './components/SectionFive';
import SectionSix from './components/SectionSix';
import SectionSeven from './components/SectionSeven';
import FaqSection from './components/FaqSection';
import SectionNine from './components/SectionNine';
import InfiniteScrollSection from './components/InfiniteScrollSection';
import Loader from './components/Loader';
import useWake from './helpers/useWakeServer';

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { isWaking, wakeServer, shouldWakeServer } = useWake();

  function toggleMobileMenuOpen() {
    setMobileMenuOpen(!mobileMenuOpen);
  }

  useEffect(() => {
    async function wake() {
      if (shouldWakeServer()) {
        await wakeServer();
      }
    }

    wake();
  }, [shouldWakeServer, wakeServer]);

  useEffect(() => {
    // Simulate a short loading period (e.g., 1-2 seconds)
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    // Cleanup timeout when the component unmounts
    return () => clearTimeout(timeout);
  }, []);

  if (isLoading) return <Loader loading={isLoading || isWaking} />;

  return (
    <>
      <MobileSideMenu open={mobileMenuOpen} toggleOpen={toggleMobileMenuOpen} />
      <Header toggleMobileMenu={toggleMobileMenuOpen} />
      <main className="flex flex-col">
        <HeroSection />
        <section className="md:hidden">
          <img src={MobileDevices} className="w-full" alt="" />
        </section>
        <SectionTwo />
        <InfiniteScrollSection />
        <SectionFour />
        <SectionFive />
        <SectionSix />
        <SectionSeven />
        <FaqSection />
        <SectionNine />
      </main>
      <Footer />
      <ToastContainer containerId={1} />
      <ToastContainer containerId={2} />
      <ToastContainer containerId={3} />
      <ToastContainer containerId={4} />
      <ToastContainer containerId={5} />
      <ToastContainer containerId={6} />
    </>
  );
}

export default App;
